import './styles.css'
import ReactDOM from 'react-dom/client'
import { useEffect } from 'react'
// import { BrowserRouter, Route } from 'react-router-dom'

import { Canvas, extend } from '@react-three/fiber'
import App from './App'
import MediaQuery from 'react-responsive'
import { BrowserRouter } from 'react-router-dom'



const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(

<BrowserRouter>
<App/>
</BrowserRouter>




)
